/* ============================================================
   F&P Filter Drawer — Desktop only (750px+)
   Intercepts native Filter button, shows custom overlay,
   applies via #FacetFiltersForm input event
   ============================================================ */

(function() {
  if (window.innerWidth < 750) return;

  let state = { types: [], tags: [], priceMin: '', priceMax: '', sort: '' };

  function readState() {
    state.types = [];
    state.tags = [];
    document.querySelectorAll('#FacetFiltersForm input[name="filter.p.product_type"]:checked').forEach(i => state.types.push(i.value));
    document.querySelectorAll('#FacetFiltersForm input[name="filter.p.tag"]:checked').forEach(i => state.tags.push(i.value));
    const gte = document.querySelector('#FacetFiltersForm input[name="filter.v.price.gte"]');
    const lte = document.querySelector('#FacetFiltersForm input[name="filter.v.price.lte"]');
    if (gte) state.priceMin = gte.value || '';
    if (lte) state.priceMax = lte.value || '';
    const sort = document.querySelector('#FacetFiltersForm select[name="sort_by"]') || document.querySelector('select[name="sort_by"]');
    if (sort) state.sort = sort.value || '';
  }

  function applyFilters() {
    const form = document.getElementById('FacetFiltersForm');
    if (!form) { closeDrawer(); return; }
    form.querySelectorAll('input[name="filter.p.product_type"]').forEach(i => { i.checked = state.types.includes(i.value); });
    form.querySelectorAll('input[name="filter.p.tag"]').forEach(i => { i.checked = state.tags.includes(i.value); });
    const gte = form.querySelector('input[name="filter.v.price.gte"]');
    const lte = form.querySelector('input[name="filter.v.price.lte"]');
    if (gte) gte.value = state.priceMin;
    if (lte) lte.value = state.priceMax;
    const sortEl = form.querySelector('select[name="sort_by"]') || document.querySelector('select[name="sort_by"]');
    if (sortEl && state.sort) sortEl.value = state.sort;
    form.dispatchEvent(new Event('input', { bubbles: true }));
    closeDrawer();
  }

  function getOptions(name) {
    const items = [];
    document.querySelectorAll(`#FacetFiltersForm input[name="${name}"]`).forEach(input => {
      const label = input.closest('li')?.querySelector('.facet-checkbox');
      const countEl = label?.querySelector('.caption-with-letter-spacing');
      const count = countEl ? countEl.textContent.replace(/[()]/g,'').trim() : '';
      items.push({ value: input.value, count });
    });
    return items;
  }

  function getSortOptions() {
    const items = [];
    document.querySelectorAll('.facet-filters__sort input[type="radio"]').forEach(input => {
      items.push({ value: input.value, label: input.closest('.facet-checkbox')?.querySelector('.label')?.textContent?.trim() || input.value });
    });
    // fallback to select
    if (!items.length) {
      document.querySelectorAll('select[name="sort_by"] option').forEach(opt => {
        items.push({ value: opt.value, label: opt.textContent.trim() });
      });
    }
    return items;
  }

  function buildChipGroup(container, options, stateKey) {
    container.innerHTML = '';
    options.forEach(opt => {
      const chip = document.createElement('div');
      chip.className = 'fp-chip' + (state[stateKey].includes(opt.value) ? ' on' : '');
      chip.innerHTML = opt.value + (opt.count ? ` <span class="fp-chip-c">(${opt.count})</span>` : '');
      chip.addEventListener('click', () => {
        const arr = state[stateKey];
        const idx = arr.indexOf(opt.value);
        if (idx > -1) arr.splice(idx, 1); else arr.push(opt.value);
        chip.classList.toggle('on', arr.includes(opt.value));
        updateCounts();
      });
      container.appendChild(chip);
    });
  }

  function buildSortChips(container) {
    container.innerHTML = '';
    getSortOptions().forEach(opt => {
      const chip = document.createElement('div');
      chip.className = 'fp-chip' + (state.sort === opt.value ? ' on' : '');
      chip.textContent = opt.label;
      chip.addEventListener('click', () => {
        state.sort = opt.value;
        container.querySelectorAll('.fp-chip').forEach(c => c.classList.remove('on'));
        chip.classList.add('on');
        updateCounts();
      });
      container.appendChild(chip);
    });
  }

  function buildChips() {
    buildChipGroup(document.getElementById('fp-chips-type'), getOptions('filter.p.product_type'), 'types');
    buildChipGroup(document.getElementById('fp-chips-tags'), getOptions('filter.p.tag'), 'tags');
    buildSortChips(document.getElementById('fp-chips-sort'));
    const pmin = document.getElementById('fp-pmin');
    const pmax = document.getElementById('fp-pmax');
    if (pmin) { pmin.value = state.priceMin; pmin.oninput = () => { state.priceMin = pmin.value; updateCounts(); }; }
    if (pmax) { pmax.value = state.priceMax; pmax.oninput = () => { state.priceMax = pmax.value; updateCounts(); }; }
    updateCounts();
  }

  function updateCounts() {
    const tc = state.types.length, tg = state.tags.length;
    const hp = state.priceMin || state.priceMax;
    const set = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };
    set('fp-cnt-type', tc ? `+${tc}` : '');
    set('fp-cnt-tags', tg ? `+${tg}` : '');
    set('fp-cnt-price', hp ? '✓' : '');
    const total = tc + tg + (hp ? 1 : 0);
    const btn = document.getElementById('fp-apply');
    if (btn) { btn.textContent = total ? `Apply (${total})` : 'Apply'; btn.style.background = total ? '#2d6a4f' : '#1a1a1a'; }
  }

  function toggle(id) {
    const body = document.getElementById('fp-body-' + id);
    const chev = document.getElementById('fp-chev-' + id);
    if (!body) return;
    body.classList.toggle('open');
    if (chev) chev.classList.toggle('open');
  }

  function clearAll() {
    state = { types: [], tags: [], priceMin: '', priceMax: '', sort: '' };
    buildChips();
  }

  function injectModal() {
    if (document.getElementById('fp-desktop-modal')) return;

    const el = document.createElement('div');
    el.id = 'fp-desktop-modal';
    el.innerHTML = `
      <div id="fp-overlay-bg"></div>
      <div id="fp-overlay-panel">
        <div id="fp-overlay-header">
          <span id="fp-overlay-title">Filter &amp; Sort</span>
          <button id="fp-overlay-close">×</button>
        </div>
        <div id="fp-overlay-body">
          <div class="fp-sec">
            <div class="fp-sec-hdr" onclick="fpToggle('type')">
              <span class="fp-sec-lbl">Shop By Type</span>
              <span class="fp-sec-cnt" id="fp-cnt-type"></span>
              <span class="fp-chev open" id="fp-chev-type">›</span>
            </div>
            <div class="fp-sec-body open" id="fp-body-type"><div class="fp-chips" id="fp-chips-type"></div></div>
          </div>
          <div class="fp-sec">
            <div class="fp-sec-hdr" onclick="fpToggle('tags')">
              <span class="fp-sec-lbl">More Filters</span>
              <span class="fp-sec-cnt" id="fp-cnt-tags"></span>
              <span class="fp-chev" id="fp-chev-tags">›</span>
            </div>
            <div class="fp-sec-body" id="fp-body-tags"><div class="fp-chips" id="fp-chips-tags"></div></div>
          </div>
          <div class="fp-sec">
            <div class="fp-sec-hdr" onclick="fpToggle('price')">
              <span class="fp-sec-lbl">Price</span>
              <span class="fp-sec-cnt" id="fp-cnt-price"></span>
              <span class="fp-chev" id="fp-chev-price">›</span>
            </div>
            <div class="fp-sec-body" id="fp-body-price">
              <div class="fp-price-row">
                <div class="fp-pf"><label>From</label><div class="fp-piw"><span>£</span><input type="number" id="fp-pmin" placeholder="0"/></div></div>
                <div class="fp-pf"><label>To</label><div class="fp-piw"><span>£</span><input type="number" id="fp-pmax" placeholder="298"/></div></div>
              </div>
            </div>
          </div>
          <div class="fp-sec">
            <div class="fp-sec-hdr" onclick="fpToggle('sort')">
              <span class="fp-sec-lbl">Sort By</span>
              <span class="fp-sec-cnt" id="fp-cnt-sort"></span>
              <span class="fp-chev" id="fp-chev-sort">›</span>
            </div>
            <div class="fp-sec-body" id="fp-body-sort"><div class="fp-chips" id="fp-chips-sort"></div></div>
          </div>
        </div>
        <div id="fp-overlay-footer">
          <button id="fp-clear" onclick="fpClearAll()">Clear all</button>
          <button id="fp-apply" onclick="fpApply()">Apply</button>
        </div>
      </div>
      <style>
        #fp-desktop-modal { position:fixed; inset:0; z-index:10000; display:none; font-family:var(--font-body-family); }
        #fp-desktop-modal.open { display:block; }
        #fp-overlay-bg { position:fixed; inset:0; background:rgba(0,0,0,0.45); backdrop-filter:blur(2px); }
        #fp-overlay-panel { box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25), 0 8px 20px rgba(0, 0, 0, 0.12);position:fixed; top:50%; left:50%; transform:translate(-50%,-50%); width:100%; max-width:56rem; max-height:88vh; background:#fff; border-radius:1.6rem; overflow:hidden; display:flex; flex-direction:column; }
        #fp-overlay-header { display:flex; align-items:center; justify-content:space-between; padding:2rem 2.4rem 1.8rem; border-bottom:1px solid #e8e8e8; flex-shrink:0; background:#fff; }
        #fp-overlay-title {	font-family: 'Playfair Display',serif;	font-size: 22px;	color: #1a1a1a;	font-weight: 700;	line-height: 1.2;}
        #fp-overlay-close { width:3.4rem; height:3.4rem; border-radius:50%; border:1px solid #e0e0e0; background:#fff; cursor:pointer; font-size:2rem; color:#555; display:flex; align-items:center; justify-content:center; }
        #fp-overlay-body { flex:1; overflow-y:auto; padding:0 2.4rem; }
        #fp-overlay-footer { display:flex; gap:1rem; padding:1.4rem 2.4rem 2rem; border-top:1px solid #e8e8e8; flex-shrink:0; background:#fff; }
        #fp-clear { flex:1; padding:1.3rem; background:#fff; color:#1a1a1a; border:1.5px solid #e0e0e0; border-radius:1rem; font-family:var(--font-body-family); font-size:1.3rem; font-weight:700; cursor:pointer; }
        #fp-apply { flex:2; padding:1.3rem; background:#1a1a1a; color:#fff; border:none; border-radius:1rem; font-family:var(--font-body-family); font-size:1.3rem; font-weight:700; cursor:pointer; letter-spacing:0.04em; }
        .fp-sec { border-bottom:1px solid #f0f0f0; }
        .fp-sec-hdr { display:flex; align-items:center; padding:1.4rem 0; cursor:pointer; gap:0.8rem; }
        .fp-sec-lbl { font-size:1.1rem; font-weight:700; letter-spacing:0.14em; text-transform:uppercase; color:#1a1a1a; flex:1; }
        .fp-sec-cnt { font-size:1.1rem; font-weight:700; color:#2d6a4f; }
        .fp-chev { font-size:1.6rem; color:#bbb; transition:transform 0.2s; display:inline-block; }
        .fp-chev.open { transform:rotate(90deg); }
        .fp-sec-body { display:none; padding-bottom:1.4rem; }
        .fp-sec-body.open { display:block; }
        .fp-chips { display:flex; flex-wrap:wrap; gap:0.8rem; }
        .fp-chip { display:inline-flex; align-items:center; gap:0.5rem; padding:0.7rem 1.4rem; border:1.5px solid #e0e0e0; border-radius:2rem; background:#fff; cursor:pointer; font-family:var(--font-body-family); font-size:1.3rem; font-weight:600; color:#555; transition:all 0.15s; white-space:nowrap; }
        .fp-chip.on { border-color:#1a1a1a; border-width:2px; color:#1a1a1a; }
        .fp-chip-c { font-size:1.1rem; color:#bbb; font-weight:400; }
        .fp-chip.on .fp-chip-c { color:#666; }
        .fp-price-row { display:flex; gap:1rem; }
        .fp-pf { flex:1; display:flex; flex-direction:column; gap:0.5rem; }
        .fp-pf label { font-size:1rem; font-weight:700; letter-spacing:0.1em; text-transform:uppercase; color:#aaa; }
        .fp-piw { display:flex; align-items:center; border:1.5px solid #e0e0e0; border-radius:0.8rem; padding:0 1.2rem; }
        .fp-piw span { font-size:1.3rem; color:#888; flex-shrink:0; }
        .fp-piw input { border:none; outline:none; font-size:1.3rem; font-family:var(--font-body-family); color:#1a1a1a; padding:0.9rem 0 0.9rem 0.4rem; width:100%; background:transparent; }
      </style>`;

    document.body.appendChild(el);
    document.getElementById('fp-overlay-close').addEventListener('click', closeDrawer);
    document.getElementById('fp-overlay-bg').addEventListener('click', closeDrawer);
  }

  window.fpToggle = toggle;
  window.fpApply = applyFilters;
  window.fpClearAll = clearAll;

  function openDrawer() {
    injectModal();
    readState();
    buildChips();
    document.getElementById('fp-desktop-modal').classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    const m = document.getElementById('fp-desktop-modal');
    if (m) m.classList.remove('open');
    document.body.style.overflow = '';
  }

  function init() {
    // Hide native facets__display on desktop
    const style = document.createElement('style');
    style.textContent = '@media(min-width:750px){facet-drawer .facets__display{display:none!important}}';
    document.head.appendChild(style);

    document.addEventListener('click', function(e) {
      if (window.innerWidth < 750) return;
      const trigger = e.target.closest('summary.facets__summary') || e.target.closest('.facets__open');
      if (trigger) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openDrawer();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
